import { IOEventsList } from '../IOEventsList/components/IOEventsList';

export function EventsListFrame() {
  return (
    <div className="events-management">
      <IOEventsList iframe />
    </div>
  );
}
